import { Badge } from '@anyemp/ui-kit';

const STATUS = {
  open: { label: 'Open', color: 'info' },
  in_progress: { label: 'In progress', color: 'warning' },
  resolved: { label: 'Resolved', color: 'success' },
  closed: { label: 'Closed', color: 'neutral' },
};

const PRIORITY = {
  low: 'neutral',
  medium: 'info',
  high: 'warning',
  critical: 'error',
};

// Dot color per priority — scannable in dense lists/tables.
const PRIORITY_DOT = {
  low: 'bg-fg-tertiary',
  medium: 'bg-info',
  high: 'bg-warning',
  critical: 'bg-error',
};

export function StatusBadge({ status, size = 'small' }) {
  const s = STATUS[status] || { label: status, color: 'neutral' };
  return <Badge label={s.label} color={s.color} variant="subtle" size={size} />;
}

export function PriorityBadge({ priority, size = 'small' }) {
  return <Badge label={priority} color={PRIORITY[priority] || 'neutral'} variant="outlined" size={size} />;
}

export function PriorityDot({ priority }) {
  return (
    <span
      title={`Priority: ${priority}`}
      className={`inline-block w-2 h-2 rounded-full ${PRIORITY_DOT[priority] || PRIORITY_DOT.low} ${priority === 'critical' ? 'animate-pulse' : ''}`}
    />
  );
}

export function formatDate(value) {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString();
  } catch {
    return String(value);
  }
}

// Friendly relative time ("just now", "5m", "3h", "2d"), falls back to a date.
export function timeAgo(value) {
  if (!value) return '';
  const d = new Date(value);
  const diff = Date.now() - d.getTime();
  if (Number.isNaN(diff)) return String(value);
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return 'just now';
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `${day}d`;
  return d.toLocaleDateString();
}
